const uz = {
    meta: {
        title: "Sayt turlari: qaysi biri kimga kerak va narxi",
        description:
            "Sayt turlari: vizitka, landing page, korporativ sayt va internet do'kon. Har biri kimga mos, qancha turadi, qancha vaqtda o'zini oqlaydi va qachon xato bo'ladi.",
        keywords: [
            "sayt turlari",
            "web saytlar turlari",
            "vizitka sayt",
            "landing page",
            "korporativ sayt",
            "qanday sayt kerak",
            "sayt tanlash",
        ],
    },
    h1: "Sayt turlari: qaysi biri sizning biznesingizga kerak",
    lead:
        "«Sayt kerak» degan gap «transport kerak» degan gapga o'xshaydi — velosipedmi yoki fura, ikkisi butunlay boshqa narx va boshqa vazifa. Quyida sayt turlarini bir-biridan ajratamiz: har biri kimga mos, qancha turadi va qancha vaqtda o'zini oqlaydi.",
    category: "Veb-saytlar",
    readingTime: "10 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Sayt — umumiy tushuncha. Uning ko'rinishi va bajaradigan vazifasiga qarab bir necha turga bo'linadi va shu tur narxni ikki-uch barobar o'zgartiradi. Noto'g'ri tanlangan tur esa faqat pulni emas, bir necha oyni ham yeydi.",
        },

        { type: "h2", text: "Nega «sayt» degan bitta so'z yetarli emas?" },
        {
            type: "p",
            text:
                "Chunki sayt turi uning bajaradigan bitta asosiy vazifasi bilan belgilanadi. Landing page bitta harakatga — ariza qoldirishga ishlaydi. Korporativ sayt ishonch beradi va ko'p xizmatni tushuntiradi. Internet do'kon esa pulni to'g'ridan-to'g'ri qabul qiladi.",
        },
        {
            type: "p",
            text:
                "Amaliyotimizda eng ko'p uchraydigan xato shu: mijoz korporativ sayt buyurtma qiladi, lekin unga reklama uchun bitta sotuvchi sahifa kerak edi. Natijada byudjet ikki barobar sarflanadi va konversiya past chiqadi, chunki ko'p sahifali saytda tashrif buyuruvchining e'tibori tarqaladi.",
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Shuning uchun tanlashni dizayndan emas, savoldan boshlaymiz: sayt kirgan odam nima qilishi kerak? Qo'ng'iroq qilishimi, ariza qoldirishimi, katalogni ko'rib chiqishimi yoki darhol sotib olishimi. Javob turni o'zi belgilab beradi.",
        },

        { type: "h2", text: "Vizitka sayt kimga mos?" },
        {
            type: "p",
            text:
                "Vizitka sayt — 3–5 sahifadan iborat eng sodda tur: bosh sahifa, xizmatlar, biz haqimizda va aloqa. Vazifasi bitta — sizni internetda topib bo'ladigan va rasmiy ko'rinadigan qilish. Kim ekaningiz, nima qilishingiz, qancha turishi va qanday bog'lanish mumkinligi shu yerda yoziladi.",
        },
        {
            type: "p",
            text:
                "Kimga mos: yuristlar, shifokorlar, repetitorlar, kichik ustaxonalar, ta'mirlash brigadalari, yangi ochilgan xizmat kompaniyalari. Ya'ni xizmat ko'rsatadigan va mijoz bilan telefon orqali gaplashadigan har kimga.",
        },
        {
            type: "p",
            text:
                "Narxi Innobek'da 5 000 000 so'mdan boshlanadi, muddati 7–12 ish kuni. Beshta sahifa, individual dizayn va admin panel bilan variant 11 000 000 so'mdan. Kamchiligi ham bor: vizitka sayt ko'p trafik olib kelmaydi, chunki unda indekslanadigan sahifa kam. U ishonch uchun ishlaydi, o'sish uchun emas.",
        },

        { type: "h2", text: "Landing page kimga mos?" },
        {
            type: "p",
            text:
                "Landing page — bitta uzun sahifa, unda bitta taklif va bitta harakat bor. Foydalanuvchining e'tibori boshqa bo'limlarga tarqalmaydi: u yo ariza qoldiradi, yo chiqib ketadi. Aynan shuning uchun landing page konversiyasi ko'p sahifali saytdan yuqori bo'ladi.",
        },
        {
            type: "p",
            text:
                "Kimga mos: reklama oqimi bilan ishlaydiganlar, bitta mahsulot yoki bitta aksiyani sotayotganlar, yangi g'oyani tez tekshirmoqchi bo'lganlar. Agar oyiga reklama byudjetingiz bo'lmasa, landing page deyarli ishlamaydi — u organik qidiruvdan kam trafik oladi.",
        },
        {
            type: "p",
            text:
                "Narxi 4 000 000 so'mdan, muddati 5–10 ish kuni. Individual dizayn, animatsiya va admin panel bilan 9 000 000 so'mdan. Kalkulyator, onlayn to'lov yoki CRM integratsiyasi kerak bo'lsa, 18 000 000 so'mdan boshlanadi.",
        },

        { type: "h2", text: "Korporativ sayt kimga mos?" },
        {
            type: "p",
            text:
                "Korporativ sayt — ko'p sahifali, to'liq tuzilmaga ega sayt. Unda kompaniya haqida batafsil ma'lumot, mahsulot va xizmatlar katalogi, narxlar, bajarilgan ishlar, yangiliklar va bo'sh ish o'rinlari bo'ladi. Foydalanuvchi buyurtma qoldirishi, fikr yozishi yoki hisob-kitob qilishi mumkin.",
        },
        {
            type: "p",
            text:
                "Kimga mos: ishlab chiqarish korxonalari, distribyutorlar, qurilish va logistika kompaniyalari, klinikalar, ta'lim markazlari — ya'ni xizmati bir nechta va mijozi uzoq o'ylab qaror qabul qiladigan biznesga.",
        },
        {
            type: "p",
            text:
                "Korporativ saytning asosiy kuchi — SEO. Har bir xizmat uchun alohida sahifa bo'lgani uchun u o'nlab so'rov bo'yicha qidiruvga chiqadi va vaqt o'tgani sari trafik o'sadi. Narxi 9 000 000 so'mdan, muddati 12–35 ish kuni. Individual dizayn va to'liq admin panel bilan 22 000 000 so'mdan; filial tizimi, shaxsiy kabinet yoki 1C integratsiyasi bilan odatda 45 mln so'mdan oshadi.",
        },

        { type: "h2", text: "Internet do'kon, promo va boshqa turlar" },
        {
            type: "p",
            text:
                "Internet do'kon — internet orqali savdoni yo'lga qo'yish uchun sayt. Katalog, savat, to'lov va yetkazib berish shu yerda birlashadi. Narxi 16 000 000 so'mdan boshlanadi, chunki bu sayt emas, ishlaydigan savdo tizimi.",
        },
        {
            type: "p",
            text:
                "Promo sayt — ma'lum bir voqea uchun yaratilgan vaqtinchalik sayt: konferensiya, ko'rgazma, konsert yoki mavsumiy aksiya. Uning muhim qoidasi bor: tadbir tugagach, sayt yopilishi yoki arxivga o'tkazilishi kerak. Amalda esa ko'pincha unday bo'lmaydi — sayt ikki yil oldingi sana bilan turaveradi va kompaniya haqida yomon taassurot qoldiradi.",
        },
        { type: "image", image: 2 },
        {
            type: "p",
            text:
                "Qolgan turlar kamroq uchraydi, lekin bilib qo'ygan ma'qul. Portal — ko'p bo'limli yirik axborot resursi. Blog yoki media — kontent orqali auditoriya yig'adigan sayt. Shaxsiy kabinet — mijoz o'z balansi, buyurtmalari va hujjatlarini ko'radigan yopiq qism. Oxirgisi ko'pincha alohida tur emas, korporativ sayt yoki do'konga qo'shiladigan modul sifatida quriladi.",
        },

        { type: "h2", text: "Qaysi turni tanlash kerak?" },
        {
            type: "p",
            text:
                "Quyidagi jadval tanlashni soddalashtiradi. Uni shunday o'qing: avval o'ng ustundagi asosiy ko'rsatkichni toping — sizning biznesingizda nima o'lchanadi, keyin qatorga qarang.",
        },
        {
            type: "table",
            head: ["Tur", "Narxi (so'm)", "Muddat", "Kimga", "Asosiy ko'rsatkich"],
            rows: [
                ["Landing page", "4 000 000 dan", "5–10 kun", "Bitta mahsulot, reklama oqimi", "Arizaning tannarxi"],
                ["Vizitka sayt", "5 000 000 dan", "7–12 kun", "Mutaxassis, kichik xizmat biznesi", "Qo'ng'iroqlar soni"],
                ["Korporativ sayt", "9 000 000 dan", "12–35 kun", "Ko'p xizmatli kompaniya", "Organik trafik va arizalar"],
                ["Internet do'kon", "16 000 000 dan", "20–60 kun", "Tovarni onlayn sotish", "Aylanma va o'rtacha chek"],
                ["Promo sayt", "4 000 000 dan", "5–15 kun", "Tadbir, ko'rgazma, aksiya", "Ro'yxatdan o'tganlar soni"],
            ],
        },
        {
            type: "callout",
            text:
                "Ikkilansangiz, kichikroq turdan boshlang. Vizitka saytni keyinroq korporativgacha kengaytirish mumkin va bu noldan qayta qurishdan arzonroq tushadi. Teskarisi esa — katta saytni kichraytirish — deyarli hech qachon foydali bo'lmaydi.",
        },

        { type: "h2", text: "Har qanday saytda bo'lishi shart bo'lgan beshta bo'lim" },
        {
            type: "p",
            text:
                "Tur qanday bo'lishidan qat'i nazar, quyidagi beshta bo'lim bo'lmasa, sayt to'liq hisoblanmaydi. Bu ro'yxat kichik biznes uchun minimal standart.",
        },
        {
            type: "list",
            items: [
                "Bosh sahifa — butun saytning qisqacha mazmuni. Bu yerda siz nima qilishingiz va mijoz nega aynan sizni tanlashi kerakligi bir ekranda tushunarli bo'lishi lozim.",
                "Biz haqimizda — foydalanuvchi kim bilan gaplashayotganini bilishi kerak. Jamoa fotosurati, tajriba yillari va rekvizitlar ishonch hosil qiladi.",
                "Xizmatlar yoki katalog — mijoz nima taklif qilinayotganini aniq ko'rishi shart. Narx ko'rsatilsa yanada yaxshi: narxsiz sahifa arizani kamaytiradi.",
                "Aloqa — telefon, manzil, ish vaqti, xarita va tezkor forma. Aloqa ma'lumotini topish uchun uch marta bosish kerak bo'lsa, odam chiqib ketadi.",
                "Huquqiy sahifalar — maxfiylik siyosati va ommaviy oferta. Ular shaxsiy ma'lumotlarni qayta ishlash bo'yicha amaldagi talablarni qoplaydi va formaga ishonchni oshiradi.",
            ],
        },

        { type: "h2", text: "Qaysi tur qancha vaqtda o'zini oqlaydi?" },
        {
            type: "p",
            text:
                "Qaytim turga emas, sizning o'rtacha chekingiz va marjangizga bog'liq. Quyida landing page misolida to'liq ochiq hisob — o'z raqamlaringizni qo'yib chiqing.",
        },
        { type: "image", image: 3 },
        {
            type: "ol",
            items: [
                "Reklama byudjeti oyiga 3 000 000 so'm, bitta klik taxminan 1 500 so'm — bu 2 000 ta tashrif.",
                "Landing konversiyasi 6% — 120 ta ariza. Bir sahifali sotuvchi sahifa uchun 5–10% real oraliq.",
                "Arizadan shartnomaga o'tish 15% — 18 ta mijoz.",
                "O'rtacha chek 1 200 000 so'm, marja 30% — bitta mijozdan 360 000 so'm sof foyda.",
                "Oylik natija: 18 × 360 000 = 6 480 000 so'm, reklamani ayirsak 3 480 000 so'm sof qoladi.",
            ],
        },
        {
            type: "p",
            text:
                "4 000 000 so'mlik landing page shu tezlikda ikkinchi oyda qoplanadi. Korporativ saytda hisob boshqacha: u reklamaga emas, organik trafikka tayanadi va sezilarli natija 4–6 oydan keyin keladi, shuning uchun qaytim odatda 8–14 oy. Internet do'kon esa o'rtacha chek va aylanmaga bog'liq — u yerda muddat 9–14 oy atrofida chiqadi.",
        },

        { type: "h2", text: "Noto'g'ri tur tanlashning narxi qancha?" },
        {
            type: "p",
            text:
                "Bu xato ikki xil ko'rinishda keladi. Birinchisi — ortiqcha to'lash. Sizga 5 mln so'mlik vizitka yetarli edi, siz 22 mln so'mlik korporativ sayt oldingiz. Farq 17 mln so'm, ustiga uch oy qo'shimcha vaqt. Bu pul reklamaga ketganda oyiga o'nlab ariza keltirardi.",
        },
        {
            type: "p",
            text:
                "Ikkinchisi va qimmatrog'i — kam to'lash. Sizga korporativ sayt kerak edi, siz landing page oldingiz. Landing page bitta so'rov bo'yicha qidiruvga chiqadi, korporativ sayt esa o'nlab so'rov bo'yicha. Yiliga 1 200 ta organik tashrifni yo'qotasiz. Yuqoridagi konversiya bilan bu taxminan 36 ta ariza, ya'ni 5 ta mijoz va o'rtacha chek 6 mln so'mda 9 mln so'mdan ortiq yo'qolgan foyda.",
        },
        {
            type: "p",
            text:
                "Uchinchi ko'rinish — qayta qurish. Noto'g'ri tanlangan saytni ikki yildan keyin noldan qayta qilishga to'g'ri keladi. Bu ikki marta to'lash demakdir va shu davrda to'plangan SEO natijasi ham qisman yo'qoladi.",
        },

        { type: "h2", text: "Qachon umuman sayt qilmaslik kerak?" },
        {
            type: "p",
            text:
                "Har bir biznesga sayt kerak degan gap noto'g'ri. Quyidagi holatlarda pulni boshqa joyga sarflagan ma'qul va biz buni mijozga ochiq aytamiz.",
        },
        {
            type: "list",
            items: [
                "Mahsulot hali tekshirilmagan. Birinchi 10 ta sotuvni qo'lda qiling — sayt gipotezani tasdiqlamaydi, u tasdiqlanganini kengaytiradi.",
                "Reklama va kontent uchun byudjet yo'q. Har qanday turdagi sayt trafiksiz ishlamaydi, bu vizitkaga ham, korporativga ham tegishli.",
                "Sotuvingiz butunlay bitta yopiq kanalga bog'langan — tender yoki bitta distribyutor. Bunda rekvizitlari bor bitta sahifa yetadi.",
                "Asosiy og'riq sayt emas, ichki tartibsizlik. Buyurtmalar yo'qolayotgan bo'lsa, avval CRM yoki Telegram bot qiling.",
                "Saytni yuritadigan odam yo'q. Yangilanmagan sayt olti oydan keyin ishonchni oshirmaydi, aksincha tushiradi.",
            ],
        },
        {
            type: "p",
            text:
                "Yana bir halol ogohlantirish: sayt turini almashtirish bilan biznes muammosi hal bo'lmaydi. Agar arizalar kelib, lekin sotuv bo'lmayotgan bo'lsa, muammo saytda emas, taklif yoki sotuv bo'limida. Bunday holda yangi sayt faqat xarajatni oshiradi.",
        },
        {
            type: "quote",
            text:
                "To'g'ri tanlangan tur — bu kamroq pul sarflash emas, balki har bir sarflangan so'mni o'lchanadigan qilish.",
        },
    ],

    faq: [
        {
            q: "Sayt turlari qanday bo'ladi?",
            a: "Amalda eng ko'p ishlatiladigan beshta tur bor: landing page — bitta taklif va bitta harakat uchun bir sahifali sayt; vizitka sayt — 3–5 sahifali oddiy sayt; korporativ sayt — ko'p xizmatli kompaniya uchun to'liq tuzilmaga ega sayt; internet do'kon — katalog, savat va to'lovi bor savdo tizimi; promo sayt — tadbir yoki aksiya uchun vaqtinchalik sayt. Portal, blog va shaxsiy kabinet kamroq uchraydi.",
        },
        {
            q: "Vizitka sayt bilan korporativ saytning farqi nimada?",
            a: "Vizitka sayt 3–5 sahifadan iborat va bitta vazifani bajaradi — sizni topib bo'ladigan hamda rasmiy ko'rinadigan qiladi. Korporativ saytda esa har bir xizmat uchun alohida sahifa bo'ladi, shuning uchun u o'nlab qidiruv so'rovi bo'yicha chiqadi va vaqt o'tgani sari trafik keltiradi. Narx farqi ham shundan: 5 mln so'mdan va 9 mln so'mdan.",
        },
        {
            q: "Menga landing page kerakmi yoki korporativ sayt?",
            a: "Savolga shunday javob bering: mijoz sizni qanday topadi? Agar reklama orqali kelsa va sizda bitta aniq taklif bo'lsa, landing page to'g'ri tanlov — u arzonroq va konversiyasi yuqori. Agar xizmatingiz bir nechta bo'lsa va mijoz qidiruvdan kelishini istasangiz, korporativ sayt kerak. Reklama byudjeti yo'q bo'lsa, landing page deyarli ishlamaydi.",
        },
        {
            q: "Qaysi sayt turi eng arzon?",
            a: "Innobek'da eng past boshlang'ich narx landing page'da — 4 000 000 so'mdan, muddati 5–10 ish kuni. Vizitka sayt 5 000 000 so'mdan boshlanadi. Lekin eng arzon variant har doim ham eng foydali emas: agar sizga korporativ sayt kerak bo'lsa, landing page olish bir necha oydan keyin qayta qurish xarajatiga olib keladi.",
        },
        {
            q: "Vizitka saytni keyinroq kengaytirish mumkinmi?",
            a: "Ha, va bu to'g'ri strategiya. Vizitka saytni bosqichma-bosqich korporativgacha o'stirish noldan qayta qurishdan arzonroq tushadi: tuzilma, dizayn va domen saqlanadi, ustiga yangi bo'limlar qo'shiladi. Shu sababli ikkilansangiz, kichikroqdan boshlashni tavsiya qilamiz. Teskari yo'nalish — katta saytni kichraytirish — deyarli hech qachon foydali chiqmaydi.",
        },
        {
            q: "Har qanday saytda qanday bo'limlar bo'lishi shart?",
            a: "Minimal standart beshta bo'limdan iborat: bosh sahifa qisqacha mazmun bilan, «biz haqimizda» jamoa va rekvizitlar bilan, xizmatlar yoki katalog narxlar bilan, aloqa sahifasi telefon, manzil va xarita bilan, hamda huquqiy sahifalar — maxfiylik siyosati va ommaviy oferta. Bu beshtasi bo'lmasa, sayt tur turidan qat'i nazar to'liq hisoblanmaydi.",
        },
        {
            q: "Noto'g'ri tur tanlasam nima bo'ladi?",
            a: "Ikki xil zarar bor. Ortiqcha to'lasangiz, kerak bo'lmagan funksiyaga pul va vaqt ketadi — masalan 5 mln so'mlik vizitka o'rniga 22 mln so'mlik korporativ sayt. Kam to'lasangiz, organik trafikni yo'qotasiz: landing page bitta so'rov bo'yicha, korporativ sayt esa o'nlab so'rov bo'yicha chiqadi. Ikkinchi xato odatda qimmatroq tushadi.",
        },
    ],

    cta: {
        h: "Qaysi tur sizga kerakligini bepul aytamiz",
        p:
            "Biznesingiz, o'rtacha chekingiz va mijozingiz sizni qanday topishini eshitib, mos turni va taxminiy byudjetni aytamiz. Kerak bo'lmasa, sayt qilmaslikni ham tavsiya qilishimiz mumkin.",
        button: "Konsultatsiya olish",
    },

    images: [
        {
            src: "/assets/img/blog/web-process.webp",
            alt: "Turli sayt turlarining tuzilishi va ularni tanlash bosqichlari sxemasi",
            caption: "Sayt turi uning bitta asosiy vazifasi bilan belgilanadi",
        },
        {
            src: "/assets/img/blog/web-cover.webp",
            alt: "Kompaniya sayti noutbuk va smartfon ekranida ochilgan holda ko'rsatilgan",
            caption: "Bir xil dizayn ortida butunlay boshqa vazifalar turishi mumkin",
        },
        {
            src: "/assets/img/blog/cleanza-arxitektura.webp",
            alt: "Sayt arxitekturasi: sahifalar tuzilmasi, admin panel va ariza oqimi bog'lanishi",
            caption: "Sayt tuzilmasi: sahifalar, admin panel va ariza oqimi",
        },
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "Sayt turiga qarab organik trafik va arizalar sonining o'sish grafigi",
            caption: "Korporativ sayt trafigi vaqt bilan o'sadi, landing page reklamaga tayanadi",
        },
    ],

    relatedServices: ["korporativ-saytlar", "landing-page", "vizitka-saytlar"],
    relatedPosts: ["web-sayt", "internetdokon"],
};

const ru = {
    meta: {
        title: "Типы сайтов: какой нужен вашему бизнесу и цена",
        description:
            "Типы сайтов: визитка, landing page, корпоративный сайт и интернет-магазин. Кому подходит каждый, сколько стоит, за сколько окупается и когда это ошибка.",
        keywords: [
            "типы сайтов",
            "виды сайтов",
            "сайт-визитка",
            "landing page",
            "корпоративный сайт",
            "какой сайт нужен",
            "выбор типа сайта",
        ],
    },
    h1: "Типы сайтов: какой из них нужен именно вашему бизнесу",
    lead:
        "Фраза «нужен сайт» похожа на «нужен транспорт»: велосипед и фура — это разные деньги и разные задачи. Разбираем типы сайтов: кому подходит каждый, сколько стоит и за какой срок окупается.",
    category: "Веб-сайты",
    readingTime: "10 минут",

    body: [
        {
            type: "p",
            text:
                "Сайт — общее понятие. По виду и выполняемой задаче он делится на несколько типов, и тип меняет цену в два-три раза. А неверно выбранный тип съедает не только деньги, но и несколько месяцев.",
        },

        { type: "h2", text: "Почему одного слова «сайт» недостаточно?" },
        {
            type: "p",
            text:
                "Потому что тип определяется одной главной задачей. Landing page работает на одно действие — оставить заявку. Корпоративный сайт формирует доверие и объясняет несколько услуг. Интернет-магазин принимает деньги напрямую.",
        },
        {
            type: "p",
            text:
                "Самая частая ошибка в нашей практике такая: клиент заказывает корпоративный сайт, хотя под рекламу ему нужна была одна продающая страница. Денег уходит вдвое больше, а конверсия получается ниже, потому что на многостраничном сайте внимание посетителя рассеивается.",
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Поэтому выбор начинается не с дизайна, а с вопроса: что должен сделать человек, который зашёл на сайт? Позвонить, оставить заявку, изучить каталог или сразу купить. Ответ сам задаёт тип.",
        },

        { type: "h2", text: "Кому подходит сайт-визитка?" },
        {
            type: "p",
            text:
                "Сайт-визитка — самый простой тип на 3–5 страниц: главная, услуги, о компании и контакты. Задача одна — сделать вас находимым в интернете и придать бизнесу официальный вид. Кто вы, чем занимаетесь, сколько это стоит и как связаться — всё пишется здесь.",
        },
        {
            type: "p",
            text:
                "Кому подходит: юристам, врачам, репетиторам, небольшим мастерским, ремонтным бригадам, недавно открывшимся сервисным компаниям. То есть всем, кто оказывает услугу и закрывает сделку по телефону.",
        },
        {
            type: "p",
            text:
                "Цена в Innobek — от 5 000 000 сум, срок 7–12 рабочих дней. Вариант на пять страниц с индивидуальным дизайном и админкой — от 11 000 000 сум. Есть и минус: визитка приносит мало трафика, потому что индексируемых страниц у неё немного. Она работает на доверие, а не на рост.",
        },

        { type: "h2", text: "Кому подходит landing page?" },
        {
            type: "p",
            text:
                "Landing page — одна длинная страница с одним предложением и одним действием. Внимание пользователя не растекается по разделам: он либо оставляет заявку, либо уходит. Именно поэтому конверсия лендинга выше, чем у многостраничного сайта.",
        },
        {
            type: "p",
            text:
                "Кому подходит: тем, кто работает с рекламным потоком, продаёт один продукт или одну акцию, быстро проверяет новую идею. Если ежемесячного рекламного бюджета нет, лендинг почти не работает — органического трафика он получает мало.",
        },
        {
            type: "p",
            text:
                "Цена — от 4 000 000 сум, срок 5–10 рабочих дней. С индивидуальным дизайном, анимацией и админкой — от 9 000 000 сум. Если нужны калькулятор, онлайн-оплата или интеграция с CRM, стоимость начинается от 18 000 000 сум.",
        },

        { type: "h2", text: "Кому подходит корпоративный сайт?" },
        {
            type: "p",
            text:
                "Корпоративный сайт — многостраничный ресурс с полной структурой. Внутри подробная информация о компании, каталог продукции и услуг, цены, выполненные работы, новости и вакансии. Пользователь может оставить заказ, написать отзыв или сделать расчёт.",
        },
        {
            type: "p",
            text:
                "Кому подходит: производствам, дистрибьюторам, строительным и логистическим компаниям, клиникам, учебным центрам — то есть бизнесу с несколькими услугами и долгим решением на стороне клиента.",
        },
        {
            type: "p",
            text:
                "Главная сила корпоративного сайта — SEO. Под каждую услугу создаётся отдельная страница, поэтому он выходит в поиск по десяткам запросов, и трафик со временем растёт. Цена — от 9 000 000 сум, срок 12–35 рабочих дней. С индивидуальным дизайном и полной админкой — от 22 000 000 сум; с системой филиалов, личным кабинетом или интеграцией с 1С обычно превышает 45 млн сум.",
        },

        { type: "h2", text: "Интернет-магазин, промо и другие типы" },
        {
            type: "p",
            text:
                "Интернет-магазин — сайт, созданный для продаж онлайн. Каталог, корзина, оплата и доставка соединяются в одном месте. Цена начинается от 16 000 000 сум, потому что это уже не сайт, а работающая торговая система.",
        },
        {
            type: "p",
            text:
                "Промо-сайт — временный сайт под конкретное событие: конференцию, выставку, концерт или сезонную акцию. У него есть важное правило: после мероприятия сайт нужно закрыть или отправить в архив. На практике так делают редко — сайт стоит с датой двухлетней давности и портит впечатление о компании.",
        },
        { type: "image", image: 2 },
        {
            type: "p",
            text:
                "Остальные типы встречаются реже, но знать их стоит. Портал — крупный информационный ресурс со множеством разделов. Блог или медиа — сайт, который собирает аудиторию контентом. Личный кабинет — закрытая часть, где клиент видит баланс, заказы и документы. Последний чаще делают не отдельным типом, а модулем к корпоративному сайту или магазину.",
        },

        { type: "h2", text: "Как выбрать нужный тип?" },
        {
            type: "p",
            text:
                "Таблица ниже упрощает выбор. Читайте её так: сначала найдите в правом столбце показатель, который вы измеряете в своём бизнесе, затем смотрите строку.",
        },
        {
            type: "table",
            head: ["Тип", "Цена (сум)", "Срок", "Кому", "Главный показатель"],
            rows: [
                ["Landing page", "от 4 000 000", "5–10 дней", "Один продукт, поток рекламы", "Стоимость заявки"],
                ["Сайт-визитка", "от 5 000 000", "7–12 дней", "Специалист, малый сервис", "Количество звонков"],
                ["Корпоративный сайт", "от 9 000 000", "12–35 дней", "Компания с рядом услуг", "Органический трафик и заявки"],
                ["Интернет-магазин", "от 16 000 000", "20–60 дней", "Продажа товаров онлайн", "Оборот и средний чек"],
                ["Промо-сайт", "от 4 000 000", "5–15 дней", "Событие, выставка, акция", "Число регистраций"],
            ],
        },
        {
            type: "callout",
            text:
                "Сомневаетесь — начните с меньшего типа. Визитку можно дорастить до корпоративного сайта, и это дешевле, чем переделывать с нуля. Обратное движение — ужимать большой сайт — почти никогда не бывает выгодным.",
        },

        { type: "h2", text: "Пять разделов, которые нужны сайту любого типа" },
        {
            type: "p",
            text:
                "Каким бы ни был тип, без пяти перечисленных ниже разделов сайт нельзя считать завершённым. Это минимальный стандарт для малого бизнеса.",
        },
        {
            type: "list",
            items: [
                "Главная — краткое содержание всего сайта. На первом экране должно быть понятно, чем вы занимаетесь и почему клиенту стоит выбрать именно вас.",
                "О компании — пользователю важно понимать, с кем он имеет дело. Фото команды, годы работы и реквизиты формируют доверие.",
                "Услуги или каталог — клиент должен чётко видеть, что ему предлагают. С ценами лучше: страница без цен снижает число заявок.",
                "Контакты — телефон, адрес, часы работы, карта и быстрая форма. Если до контактов нужно кликать трижды, человек уходит.",
                "Юридические страницы — политика конфиденциальности и публичная оферта. Они закрывают действующие требования к обработке персональных данных и повышают доверие к форме.",
            ],
        },

        { type: "h2", text: "За какой срок окупается каждый тип?" },
        {
            type: "p",
            text:
                "Окупаемость зависит не от типа, а от вашего среднего чека и маржи. Ниже полностью открытый расчёт на примере landing page — подставьте свои числа.",
        },
        { type: "image", image: 3 },
        {
            type: "ol",
            items: [
                "Рекламный бюджет 3 000 000 сум в месяц при цене клика около 1 500 сум — это 2 000 визитов.",
                "Конверсия лендинга 6% — 120 заявок. Для продающей одностраничной страницы 5–10% — реальный диапазон.",
                "Из заявки в договор переходит 15% — 18 клиентов.",
                "Средний чек 1 200 000 сум при марже 30% — 360 000 сум чистыми с клиента.",
                "Результат за месяц: 18 × 360 000 = 6 480 000 сум, минус реклама — 3 480 000 сум чистыми.",
            ],
        },
        {
            type: "p",
            text:
                "Лендинг за 4 000 000 сум при такой скорости окупается на втором месяце. У корпоративного сайта расчёт другой: он опирается не на рекламу, а на органику, и заметный результат приходит через 4–6 месяцев, поэтому окупаемость обычно 8–14 месяцев. У интернет-магазина срок зависит от оборота и среднего чека — обычно это 9–14 месяцев.",
        },

        { type: "h2", text: "Сколько стоит ошибка в выборе типа?" },
        {
            type: "p",
            text:
                "Эта ошибка приходит в двух видах. Первый — переплата. Вам хватало визитки за 5 млн сум, а вы взяли корпоративный сайт за 22 млн. Разница 17 млн сум плюс три лишних месяца. Уйди эти деньги в рекламу, они принесли бы десятки заявок в месяц.",
        },
        {
            type: "p",
            text:
                "Второй вид дороже — недоплата. Вам был нужен корпоративный сайт, а вы сделали лендинг. Лендинг выходит в поиск по одному запросу, корпоративный сайт — по десяткам. За год вы теряете около 1 200 органических визитов. При средней конверсии это примерно 36 заявок, то есть 5 клиентов, а при среднем чеке 6 млн сум — больше 9 млн сум упущенной прибыли.",
        },
        {
            type: "p",
            text:
                "Третий вид — переделка. Неверно выбранный сайт через два года приходится собирать заново. Это значит заплатить дважды и вдобавок частично потерять накопленный за это время результат SEO.",
        },

        { type: "h2", text: "Когда сайт не нужен вовсе?" },
        {
            type: "p",
            text:
                "Утверждение «сайт нужен любому бизнесу» неверно. В перечисленных случаях деньги лучше потратить иначе, и мы говорим об этом клиенту прямо.",
        },
        {
            type: "list",
            items: [
                "Продукт ещё не проверен. Сделайте первые 10 продаж вручную — сайт не подтверждает гипотезу, он масштабирует подтверждённую.",
                "Нет бюджета на рекламу и контент. Без трафика не работает сайт любого типа, включая визитку.",
                "Все продажи идут через один закрытый канал — тендер или одного дистрибьютора. Здесь хватит одной страницы с реквизитами.",
                "Главная боль не в сайте, а во внутреннем беспорядке. Если теряются заказы, начните с CRM или Telegram-бота.",
                "Некому вести сайт. Сайт, который не обновляется полгода, доверие не повышает, а снижает.",
            ],
        },
        {
            type: "p",
            text:
                "И ещё одно честное предупреждение: сменой типа сайта бизнес-проблема не решается. Если заявки приходят, а продаж нет, дело не в сайте, а в предложении или в отделе продаж. Новый сайт в этом случае только увеличит расходы.",
        },
        {
            type: "quote",
            text:
                "Правильно выбранный тип — это не про то, чтобы потратить меньше, а про то, чтобы каждый потраченный сум стал измеримым.",
        },
    ],

    faq: [
        {
            q: "Какие бывают типы сайтов?",
            a: "На практике чаще всего используют пять типов: landing page — одностраничный сайт под одно предложение и одно действие; сайт-визитка на 3–5 страниц; корпоративный сайт с полной структурой для компании с рядом услуг; интернет-магазин с каталогом, корзиной и оплатой; промо-сайт под событие или акцию. Реже встречаются портал, блог и личный кабинет.",
        },
        {
            q: "Чем сайт-визитка отличается от корпоративного сайта?",
            a: "Визитка состоит из 3–5 страниц и решает одну задачу — сделать вас находимым и придать бизнесу официальный вид. У корпоративного сайта под каждую услугу есть отдельная страница, поэтому он выходит в поиск по десяткам запросов и со временем приносит трафик. Отсюда и разница в цене: от 5 млн сум против от 9 млн сум.",
        },
        {
            q: "Что выбрать — landing page или корпоративный сайт?",
            a: "Ответьте на вопрос: как клиент вас находит? Если он приходит из рекламы и предложение у вас одно, правильный выбор — landing page: дешевле и с более высокой конверсией. Если услуг несколько и вы хотите получать клиентов из поиска, нужен корпоративный сайт. Без рекламного бюджета лендинг почти не работает.",
        },
        {
            q: "Какой тип сайта самый дешёвый?",
            a: "В Innobek самый низкий стартовый порог у landing page — от 4 000 000 сум со сроком 5–10 рабочих дней. Сайт-визитка начинается от 5 000 000 сум. Но самый дешёвый вариант не всегда самый выгодный: если вам был нужен корпоративный сайт, лендинг через несколько месяцев обернётся расходами на переделку.",
        },
        {
            q: "Можно ли позже расширить сайт-визитку?",
            a: "Да, и это верная стратегия. Дорастить визитку до корпоративного сайта поэтапно дешевле, чем пересобирать с нуля: структура, дизайн и домен сохраняются, сверху добавляются новые разделы. Поэтому при сомнениях мы советуем начинать с меньшего. Обратный путь — ужимать большой сайт — почти никогда не бывает выгодным.",
        },
        {
            q: "Какие разделы обязательны для сайта любого типа?",
            a: "Минимальный стандарт — пять разделов: главная с кратким содержанием, страница о компании с командой и реквизитами, услуги или каталог с ценами, контакты с телефоном, адресом и картой, а также юридические страницы — политика конфиденциальности и публичная оферта. Без этих пяти сайт нельзя считать завершённым независимо от типа.",
        },
        {
            q: "Что будет, если выбрать неверный тип?",
            a: "Ущерб бывает двух видов. При переплате деньги и время уходят на ненужный функционал — например, корпоративный сайт за 22 млн сум вместо визитки за 5 млн. При недоплате вы теряете органический трафик: лендинг выходит в поиск по одному запросу, корпоративный сайт — по десяткам. Вторая ошибка обычно обходится дороже.",
        },
    ],

    cta: {
        h: "Бесплатно подскажем, какой тип нужен вам",
        p:
            "Разберём задачу, средний чек и то, как клиент вас находит, назовём подходящий тип и примерный бюджет. Если сайт вам сейчас не нужен, мы это тоже скажем.",
        button: "Получить консультацию",
    },

    images: [
        {
            src: "/assets/img/blog/web-process.webp",
            alt: "Схема структуры разных типов сайтов и этапов выбора подходящего варианта",
            caption: "Тип сайта определяется его единственной главной задачей",
        },
        {
            src: "/assets/img/blog/web-cover.webp",
            alt: "Сайт компании открыт на экране ноутбука и смартфона одновременно",
            caption: "За одинаковым дизайном могут стоять совершенно разные задачи",
        },
        {
            src: "/assets/img/blog/cleanza-arxitektura.webp",
            alt: "Архитектура сайта: структура страниц, админ-панель и поток заявок",
            caption: "Структура сайта: страницы, админ-панель и поток заявок",
        },
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "График роста органического трафика и заявок в зависимости от типа сайта",
            caption: "Трафик корпоративного сайта растёт со временем, лендинг живёт рекламой",
        },
    ],

    relatedServices: ["korporativ-saytlar", "landing-page", "vizitka-saytlar"],
    relatedPosts: ["web-sayt", "internetdokon"],
};

const content = { uz, ru };

export default content;
